module.exports = __webpack_public_path__ + "media/team_photos/Sabrina-photo-d8e360f3.webp";